<template>
    <div class="server_selected" v-if="selected.length>0">
        <a-divider dashed style="margin:15px 0;"/>
        <div>
            {{$t("common.selected")}}{{label}}：
            <a-tag closable @close="closeSelect(item.value)" @click="closeSelect(item.value)" v-for="item in selected" :key="item.value" style="margin-bottom:4px">{{item.label}}</a-tag>
        </div>
    </div>
</template>

<script>
import {Tag, Divider} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Tag)
Vue.use(Divider)

export default {
    props:['label', 'value', 'options'],
    computed: {
        allvalue() {
            let all = {}
            this.options.forEach((option)=>{
                if(option.options) {
                    option.options.forEach((sub)=>{
                        all[sub.value] = sub
                    })
                } else {
                    all[option.value] = option
                }
            })
            return all
        },
        selected() {
            let val = this.value?this.value:[]
            let selected = []
            val.forEach((value)=>{
                if(this.allvalue[value]) {
                    selected.push(this.allvalue[value])
                }
            })
            return selected
        },
    },
    methods: {
        closeSelect(id) {
            let index = this.value.indexOf(id)
            if(index>=0) {
                this.value.splice(index, 1)
                this.$emit('input', this.value)
            }
        },
    }
}
</script>